/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InitialRedirect/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function InitialRedirect({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/InitialRedirect"
  
}) {
  return null
}